<mat-card data-at-firmware-update-modal>
  <mat-card-header>
    <mat-card-title>
      {{ '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.VERIFICATION.TITLE' | translate }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <app-banner
      [type]="bannerType.warning"
      isFullWidth="true"
      *ngIf="hasErrorPayload; else VerificationPassed"
    >
      {{
        '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.VERIFICATION.FAILED_DESCRIPTION'
          | translate
      }}
    </app-banner>

    <ng-template #VerificationPassed>
      <app-banner [type]="bannerType.success" isFullWidth="true"
        >{{
          '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.VERIFICATION.SUCCESS_DESCRIPTION'
            | translate
        }}
      </app-banner>
    </ng-template>

    <ng-container *ngrxLet="firmwareUpdateStore.processType$ as processType">
      <div class="border rounded-lg bg-white mt-4">
        <div *ngFor="let message of messages" class="flex flex-col">
          <div class="flex gap-2 justify-between p-4">
            <div class="flex flex-col">
              <p class="status-message__title">{{ message.title | translate }}</p>
              <span
                *ngIf="
                  !message.status &&
                  !(message.errorStatus === componentVerficationBooleanValue.TRUE)
                "
              >
                {{ message.description | translate }}
              </span>
              <button
                *ngIf="
                  message.id === componentVerificationTypeValue.LEGAL_APPROVED &&
                    !message.status &&
                    processType === firmwareupdateProcessType.CheckForBundleUpdate &&
                    isEnableOneTimeServiceApprovalButton &&
                    authStore.isRsaXotaApplicationRole$ | async
                "
                data-at-firmware-update-modal-one-time-approval
                mat-raised-button
                color="primary"
                class="mt-2 w-fit lt-md:order-1"
                gtm="onClick"
                gtmCategory="firmwareUpdate"
                gtmAction="open one time service approval modal"
                (click)="openOneTimeServiceApprovalModal()"
              >
                {{
                  '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.ONE_TIME_APPROVAL.TITLE'
                    | translate
                }}
              </button>
            </div>
            <ng-container *ngIf="hasErrorPayload; else allPassed">
              <ng-container
                *ngIf="message.errorStatus === componentVerficationBooleanValue.TRUE; else failed"
              >
                <mat-icon class="check-icon">check_circle</mat-icon>
              </ng-container>
              <ng-template #failed>
                <mat-icon class="warning-icon">error</mat-icon>
              </ng-template>
            </ng-container>

            <ng-template #allPassed>
              <mat-icon class="check-icon">check_circle</mat-icon>
            </ng-template>
          </div>

          <hr />
        </div>
      </div>
    </ng-container>
  </mat-card-content>

  <mat-card-actions class="!flex flex-row lt-md:flex-col gap-3 justify-end items-center">
    <ng-container *ngIf="!hasErrorPayload; else showCloseButton">
      <button
        data-at-firmware-update-modal-next
        mat-raised-button
        color="primary"
        class="fill-btn lt-md:order-1"
        gtm="onStart"
        gtmCategory="firmwareUpdate"
        gtmAction="Start firmware update installation"
        (click)="onContinueCheckingProgress()"
      >
        {{ 'GENERAL.BUTTON.CONTINUE' | translate }}
      </button>
    </ng-container>

    <ng-template #showCloseButton>
      <button
        data-at-firmware-update-modal-finish
        mat-raised-button
        color="primary"
        class="fill-btn lt-md:order-1"
        gtm="onFinishDialog"
        gtmCategory="firmwareUpdate"
        gtmAction="Finish firmware update modal"
        (click)="onClose()"
      >
        {{ 'GENERAL.BUTTON.FINISH' | translate }}
      </button>
    </ng-template>
  </mat-card-actions>
</mat-card>
